"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonOkResponseFetchGraphqlError = void 0;
var _axios = require("@ori/axios");
var _FetchGraphqlError = require("./FetchGraphqlError");
/**
 * Error that indicates that fetch to graphql server was returned with status code that
 * it is not 200, but also lower than 500 HTTP status code
 */
class NonOkResponseFetchGraphqlError extends _FetchGraphqlError.FetchGraphqlError {
  constructor(response, query) {
    const message = 'Non OK response has been returned from GraphQl server';
    // eslint-disable-next-line unicorn/custom-error-definition -- okay in this case
    super(new _axios.AxiosError(message, _axios.AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response), query);
    this.name = 'NonOkResponseFetchGraphqlError';
    this.message = message;
  }
}
exports.NonOkResponseFetchGraphqlError = NonOkResponseFetchGraphqlError;
//# sourceMappingURL=NonOkResponseFetchGraphqlError.js.map